import React, {useEffect} from 'react';

import {useParams} from 'react-router-dom'

import {useDispatch, useSelector} from "react-redux";
import {getActTemplate, loadingActTemplate} from "../../redux/reducers/act-template-reducer";
import {createAct, createActLock, getActs, loadAct, patchAct, patchActLock} from "../../redux/reducers/act-reducer";
import {
    getActiveEnvironmentState,
    loadEnvironmentState,
    loadingActiveEnvironmentState
} from "../../redux/reducers/master-of-acts-reducer";
import {getHandbooks, loadingHandbook} from "../../redux/reducers/handbook-reducer";
import {getProjects} from "../../redux/reducers/project-reducer";
import {getProfile} from "../../redux/reducers/user-profile-reducer";

import {CommonLayout} from "../../layouts/CommonLayout/CommonLayout";
import {ActFillingContainer} from "../../containers/ActFillingContainer/ActFillingContainer";
import { UserRoles } from '../../utils/roles';
import { allProjectSupervisors, loadProjectSupervisor } from '../../redux/reducers/users-reducer';


export const ActPage = () => {
    
    const {actId} = useParams()


    const {selectedAct, loading: loadingActs} = useSelector(getActs)

    const {actTemplate, loading: actTemplateLoading} = useSelector(getActTemplate)
    const {selectedProject, loading: projectLoading} = useSelector(getProjects)
    const activeEnvironmentState = useSelector(getActiveEnvironmentState)
    const {selectedHandbook} = useSelector(getHandbooks)
    const {user} = useSelector(getProfile)

    const  youSupervisors  = useSelector(allProjectSupervisors)



    const dispatch = useDispatch()

    const handlePatchAct = (id, {name, content, rawContent, status, comments, files, environmentStateId, creatorId, field_contractor, violations}) => {
        dispatch(patchAct(id, {
            name,
            content,
            rawContent,
            status,
            comments,
            files: files?.map(el => el.id),
            environmentStateId,
            creatorId,
            field_contractor,
            violations
        }))
    }

    const handlePatchActLock = (id, {name, content, rawContent, status, comments, files, environmentStateId, creatorId, violations}) => {
        dispatch(patchActLock(id, {
            name,
            content,
            rawContent,
            status,
            comments,
            files: files?.map(el => el.id),
            environmentStateId,
            creatorId,
            violations
        }))
    }
   

    const handleCreateAct = ({name, content, rawContent, status, comments, files, environmentStateId, creatorId, field_contractor, violations}) => {
        dispatch(createAct({
            name,
            content,
            rawContent,
            status,
            comments,
            files: files?.map(el => el.id),
            environmentStateId,
            creatorId,
            field_contractor,
            violations,
        }))
    }

    const handleCreateActLock = ({name, content, rawContent, status, comments, files, environmentStateId, creatorId, violations}) => {
        dispatch(createActLock({
            name,
            content,
            rawContent,
            status,
            comments,
            files: files?.map(el => el.id),
            environmentStateId,
            creatorId,
            violations
        }))
    }

    useEffect(() => {
        if (actId) {
            dispatch(loadAct(actId))
            
        }
    }, [dispatch, actId])

    useEffect(() => {
        if (!activeEnvironmentState || selectedProject?.id && !actId && activeEnvironmentState?.project !== selectedProject?.id) {
            dispatch(loadingActiveEnvironmentState(selectedProject.id))
        }
    }, [dispatch, selectedProject])

    useEffect(() => {
        if (activeEnvironmentState && ((selectedAct && activeEnvironmentState?.id === selectedAct?.environment_state) ||
            (activeEnvironmentState?.project === selectedProject?.id && selectedProject && !actId))) {
            dispatch(loadingActTemplate(activeEnvironmentState.act_template))
            dispatch(loadingHandbook(activeEnvironmentState.handbook))
        }
    }, [activeEnvironmentState, selectedProject, actId, selectedAct])

    useEffect(() => {
        if (selectedAct && selectedAct.environment_state !== activeEnvironmentState?.id) {
            dispatch(loadEnvironmentState(selectedAct.environment_state))
        }
    }, [selectedAct])

    useEffect(() => {
        if (user.role === UserRoles.FIELD_CONTRACTOR && selectedProject) {
            dispatch(loadProjectSupervisor(selectedProject?.contract))
        }
    }, [])

    return <CommonLayout>
        {
            !actTemplateLoading &&
            !projectLoading &&
            selectedProject &&
            actTemplate &&
            activeEnvironmentState?.act_template === actTemplate?.id &&
            activeEnvironmentState?.project === selectedProject?.id &&
            activeEnvironmentState?.handbook === selectedHandbook?.id ?
                <ActFillingContainer actTemplate={actTemplate}
                                     activeEnvironmentState={activeEnvironmentState}
                                     selectedAct={selectedAct}
                                     selectedProject={selectedProject}
                                     user={user}
                                     handlePatchAct={handlePatchAct}
                                     handleCreateAct={handleCreateAct}
                                     handlePatchActLock={handlePatchActLock}
                                     handleCreateActLock={handleCreateActLock}
                                     youSupervisors={youSupervisors}
                /> : 'Loading...'}
    </CommonLayout>
}